"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodParsedType = void 0;
var util_1 = require("./helpers/util");
exports.ZodParsedType = util_1.util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
]);
//# sourceMappingURL=ZodParsedType.js.map